// Route names constants.js
export default {
    RN_HOME_PUBLIC: "HomePublic",
    RN_HOME: "Home",
    RN_DASHBOARD: "Dashboard",
    RN_USER_SETTINGS: "UserSettings",
    RN_LOGIN: "Login",
    RN_APPLICANTS:"ApplicantList",
    RN_APPLICANT:"Applicant",
    RN_APPLICANT_BASIC:"ApplicantBasic",
    RN_APPLICANT_BASIC_VIEW:"ApplicantBasicView",
    RN_APPLICANT_NEW:"ApplicantNew",
    RN_RECOGNITION_DATA:"RecognitionData",
    RN_RECOGNITION_DECISION_DATA:"RecognitionDecisionData",
    RN_APPLICANT_DOCUMENT:"ApplicantDocument",
    RN_USER_LIST:"UserList",
    RN_INSTITUTIONS:"InstitutionsList",
    RN_RESET_PASSWORD:"ResetPassword",
    RN_CONTACTS:"ContactsList",
    RN_RECOGNITION_EVALUATION_DATA: "RecognitionEvaluationData",
    RN_RECOGNITION_DECISION_DOCUMENT: "RecognitionDecisionDocument",
    RN_PUBLIC_STATISTIC: "PublicStatistic",
    RN_PUBLIC_QUALIFICATION_DATA: "PublicQualificationData",
    RN_LOGS:"LogList",
    RN_PRIVACY_POLICY:"PrivacyPolicy",
}
